<button
  *ngrxLet="isDisabled$ as disabled"
  mat-raised-button
  class="image !h-full"
  matTooltip="DTX Studio integration requires patient date of birth"
  [matTooltipDisabled]="!disabled"
  [matMenuTriggerFor]="menu"
  [disabled]="disabled"
>
  <div class="flex items-center gap-1">
    DTX Studio
    <mat-icon>arrow_drop_down</mat-icon>
  </div>
</button>

<mat-menu #menu="matMenu">
  @for (feature of integrationFeatures; track feature.command) {
    <button (click)="openDtxStudio(feature.command)" mat-menu-item>
      {{ feature.label }}
    </button>
  }
</mat-menu>
